import { getMaterialOptions } from "../configurator/materials/materialConfig";

// Pricing configuration for the carport
export const pricingConfig = {
  basePrice: 5000, // Base price for a standard carport

  // Price calculation functions for each field
  priceRules: {
    // Breedte: price increases with width
    BREEDTE: {
      type: 'linear',
      baseValue: 6500, // Reference value in mm
      pricePerUnit: 0.15, // Euro per mm above base
      formula: (value, baseValue, pricePerUnit) => {
        const difference = value - baseValue;
        return difference * pricePerUnit;
      }
    },

    // Aantal kepers: price per keper
    AANTAL_KEPERS: {
      type: 'perUnit',
      pricePerUnit: 25, // Euro per keper
      formula: (value, pricePerUnit) => value * pricePerUnit
    },

    // Material prices for balken
    MATERIAL_BLAD: {
      type: 'materialPrice',
      prices: {
        'oak-wood': 800,
        'bare-wood1': 500,
        'subtle-grained-wood': 650
      },
      formula: (value, prices) => prices[value] || 0
    },

    // Material prices for kepers
    MATERIAL_KEPERS: {
      type: 'materialPrice',
      prices: {
        'oak-wood': 400,
        'bare-wood1': 250,
        'subtle-grained-wood': 325
      },
      formula: (value, prices) => prices[value] || 0
    },

    // Material prices for vloer
    MATERIAL_VLOER: {
      type: 'materialPrice',
      prices: {
        'grass': 0,
        'grainy-concrete': 1200,
        'wispy-grass-meadow': 0,
        'cobblestone-curved': 1500
      },
      formula: (value, prices) => prices[value] || 0
    },

    // Color surcharge for ankers
    WAND_COLOR_OUTSIDE: {
      type: 'colorPrice',
      prices: {
        'RAL 9016': 150,
        'RAL 7016': 150,
        'RAL 8019': 150,
        'RAL 9001': 150,
        'RAL 9005': 200 // Black is slightly more expensive
      },
      formula: (value, prices) => prices[value] || 0
    }
  }
};

export const formConfig = [
  /*
  {
    type: 'dimensionPicker',
    label: 'Afmetingen',
    name: 'DIMENSION',
    detailed_label: 'Wat zijn de gewenste afmetingen?',
    title: 'Afmetingen',
    defaultValue: { WIDTH: '2500', HEIGHT: '9500' },
    keyShapeIndex: {
      WIDTH: 0,
      HEIGHT: 1
    },
    fields: {
      WIDTH: { label: 'Breedte tafel (mm)', placeholder: 'Breedte', backendKey: 'breedte' },
      HEIGHT: { label: 'Hoogte tafel (mm)', placeholder: 'Hoogte', backendKey: 'hoogte' }
    },
    validation: {
      WIDTH: { required: 'Is verplicht', min: { value: 500, message: 'Moet minimaal 500mm zijn' }, max: { value: 1500, message: 'Mag minimaal 1500mm zijn' } },
      HEIGHT: { required: 'Is verplicht', min: { value: 500, message: 'Moet minimaal 500mm zijn' }, max: { value: 2500, message: 'Mag minimaal 2500mm zijn' } }
    }

  },*/



    {
    type: 'fixedValuePicker',
    label: 'Breedte',
    name: 'BREEDTE',
    detailed_label: 'Selecteer de gewenste breedte voor uw carport',
    title: 'Breedte',
    description: 'De breedte van uw carport bepaalt hoeveel ruimte er is voor uw voertuig(en). Een standaard carport heeft een breedte tussen 4,5m en 9,5m. Houd rekening met extra ruimte voor het openen van portieren en eventuele opslag.',
    defaultValue: 6500,
    backendKey: 'Lengte',
    min: 4500,
    max: 9500,
    step: 300,
    unit: 'mm',           // Backend unit
    displayUnit: 'cm',     // What the user sees
    conversionFactor: 10, // mm to m conversion (divide by 1000)
    validation: {
      required: 'Is verplicht',
      min: { value: 4500, message: 'Moet minimaal 4.5m zijn' },
      max: { value: 9500, message: 'Mag maximaal 9.5m zijn' }
    }
  },

  /*
  {
    type: 'singleDimensionPicker',
    label: 'Breedte',
    name: 'Breedte',
    detailed_label: 'Wat is de gewenste breedte?',
    title: 'Breedte',
    defaultValue: '9500',
    backendKey: 'hoogte',
    field: {
      label: 'Breedte (mm)',
      placeholder: 'Breedte'
    },
    validation: {
      required: 'Is verplicht',
      min: { value: 1500, message: 'Moet minimaal 500mm zijn' },
      max: { value: 10000, message: 'Mag maximaal 2500mm zijn' }
    }

  },*/
  {
    title: "Materiaal balken",
    detailed_label: "Welk type hout wenst u te gebruiken?",
    name: "MATERIAL_BLAD",
    label: "Materiaal",
    type: "materialPicker",
    description: "Kies het houtsoort voor de hoofdbalken van uw carport. Eikenhout is sterk en duurzaam, geschikt voor buitengebruik. Onbehandeld hout geeft een natuurlijke uitstraling. Het gekozen materiaal bepaalt de levensduur en het onderhoud van uw carport.",
    defaultValue: "oak-wood",
    backendKey: "material_blad",
    meshSelector: {
      type: "contains",
      value: ["Poot", "Body", "Gording"] // Apply to meshes starting with "Blad" or "Tafel"
    },
    meshExcluder: {
      type: "exact",
      value: ["Body022", "Body023","Keper"]  // Deze meshes krijgen NIET het materiaal
    },
    // Specify which materials are available - if not specified, all materials will be shown
    options: getMaterialOptions(["oak-wood","bare-wood1","subtle-grained-wood"]),
    validation: { required: 'Gelieve een materiaal te selecteren' }
  },

  /*
      {
    type: 'singleDimensionPicker',
    label: 'Aantal Kepers',
    name: 'AANTAL_KEPERS',
    detailed_label: 'Hoeveel kepers wens je?',
    title: 'Kepers',
    defaultValue: '25',
    backendKey: 'breedte',
    field: {
      label: 'Aantal kepers',
      placeholder: 'Aantal kepers'
    },
    validation: {
      required: 'Is verplicht',
      min: { value: 5, message: 'Moet mininmaal 5 zijn' },
      max: { value: 50, message: 'Mag maximaal 50 zijn' }
    }

  },
  */
{
    type: 'fixedValuePicker',
    label: 'Aantal kepers',
    name: 'AANTAL_KEPERS',
    detailed_label: 'Hoeveel kepers heb je nodig?',
    title: 'Kepers',
    description: 'Kepers zijn de horizontale balken die over de dakconstructie lopen en zorgen voor stabiliteit. Het aantal kepers bepaalt de sterkte en afwerking van uw carport. Meer kepers betekent een stevigere constructie en kleinere tussenruimtes.',
    defaultValue: 25,
    backendKey: 'Base_Aantal_Kepers',
    min: 2,
    max: 30,
    step: 1,
    unit: '',           // Backend unit
    displayUnit: '',     // What the user sees
    conversionFactor: 1, // mm to m conversion (divide by 1000)
    validation: {
      required: 'Is verplicht',
      min: { value: 2, message: 'Moet minimaal 2 zijn' },
      max: { value: 30, message: 'Mag maximaal 30 zijn' }
    }
  },


  {
    title: "Materiaal kepers",
    detailed_label: "Welk type hout wenst u te gebruiken?",
    name: "MATERIAL_KEPERS",
    label: "Materiaal",
    type: "materialPicker",
    description: "Selecteer het houtsoort voor de kepers. De kepers kunnen van hetzelfde materiaal zijn als de hoofdbalken, of u kunt voor een contrast kiezen. Dit materiaal is zichtbaar vanaf de onderkant en draagt bij aan de uitstraling van uw carport.",
    defaultValue: "oak-wood",
    backendKey: "material_kepers",
    meshSelector: {
      type: "contains",
      value: ["Keper"] // Apply to meshes starting with "Blad" or "Tafel"
    },
    // Specify which materials are available - if not specified, all materials will be shown
    options: getMaterialOptions(["oak-wood","bare-wood1","subtle-grained-wood"]),
    validation: { required: 'Gelieve een materiaal te selecteren' }
  },
    {
    title: "Materiaal ondergrond",
    detailed_label: "Uit welk materiaal uw ondergrond gemaakt?",
    name: "MATERIAL_VLOER",
    label: "Materiaal",
    type: "materialPicker",
    description: "Kies het type ondergrond waarop uw carport geplaatst wordt. Dit helpt om de juiste fundering en bevestigingsmethode te bepalen. Verschillende ondergronden vereisen verschillende soorten ankers en installatiemethoden.",
    defaultValue: "grainy-concrete",
    backendKey: "material_blad",
    meshSelector: {
      type: "contains",
      value: ["Vloer"] // Apply to meshes starting with "Blad" or "Tafel"
    },

    options: getMaterialOptions(["grass","grainy-concrete","wispy-grass-meadow","cobblestone-curved"]),
    validation: { required: 'Gelieve een materiaal te selecteren' }
  },
  {
    title: "Ankers",
    detailed_label: "Welke kleur wenst u voor de ankers die de palen verbinden met de grond?",
    name: "WAND_COLOR_OUTSIDE",
    label: "Kleur van het frame",
    type: "colorPicker",
    description: "De ankers verbinden de houten palen met de ondergrond en zorgen voor stabiliteit. De kleur van de ankers heeft invloed op de uitstraling van uw carport. Kies een kleur die past bij uw woning of juist contrast creëert. De ankers zijn gemaakt van gepoedercoat staal voor maximale duurzaamheid.",
    defaultValue: "RAL 9005",
    backendKey: "wand_color_outside",
    meshSelector: {
      type: "exact",
      value: ["Body022","Body023"] // matches Anker01, Anker02, etc.
    },
    options: [
      { label: "RAL 9016 glanzend (wit)", color: "#f6f6f6", code: "RAL 9016" },
      { label: "RAL 7016 glanzend (antraciet)", color: "#383e42", code: "RAL 7016" },
      { label: "RAL 8019 glanzend (bruin)", color: "#4e3b31", code: "RAL 8019" },
      { label: "RAL 9001 glanzend (crème)", color: "#fdf4e3", code: "RAL 9001" },
      { label: "RAL 9005 structuur (zwart)", color: "#0a0a0a", code: "RAL 9005" },
    ],
    validation: { required: 'Gelieve een kleur van het frame te selecteren' }
  },
  /*
  {
    title: "Soort houten balken",
    detailed_label: "Welke kleur wenst u voor het kader van uw raam?",
    name: "WINDOW_COLOR",
    label: "Kleur van het raam",
    type: "colorPicker",
    defaultValue: "RAL 8019",
    backendKey: "window_color",
    meshSelector: {
      type: "contains",
      value: ["Body","Gording"] // matches any mesh containing "Window"
    },
    options: [
      { label: "RAL 9016 glanzend (wit)", color: "#f6f6f6", code: "RAL 9016" },
      { label: "RAL 7016 glanzend (antraciet)", color: "#383e42", code: "RAL 7016" },
      { label: "RAL 8019 glanzend (bruin)", color: "#4e3b31", code: "RAL 8019" },
      { label: "RAL 9001 glanzend (crème)", color: "#fdf4e3", code: "RAL 9001" },
      { label: "RAL 9005 structuur (zwart)", color: "#0a0a0a", code: "RAL 9005" },
    ],
    validation: { required: 'Gelieve een kleur van het frame te selecteren' }
  },
    {
    title: "Vloer",
    detailed_label: "Welke kleur wenst u voor uw vloer?",
    name: "VLOER_COLOR",
    label: "Kleur van de vloer",
    type: "colorPicker",
    defaultValue: "RAL 8019",
    backendKey: "window_color",
    meshSelector: {
      type: "contains",
      value: ["Vloer"] // matches any mesh containing "Window"
    },
    options: [
      { label: "RAL 9016 glanzend (wit)", color: "#f6f6f6", code: "RAL 9016" },
      { label: "RAL 7016 glanzend (antraciet)", color: "#383e42", code: "RAL 7016" },
      { label: "RAL 8019 glanzend (bruin)", color: "#4e3b31", code: "RAL 8019" },
      { label: "RAL 9001 glanzend (crème)", color: "#fdf4e3", code: "RAL 9001" },
      { label: "RAL 9005 structuur (zwart)", color: "#0a0a0a", code: "RAL 9005" },
    ],
    validation: { required: 'Gelieve een kleur van het frame te selecteren' }
  },*/


  ];
  
  